<template lang="pug">
.subtitle-text(:id='id')
    label.subtitle-label-text {{ label }}
</template>

<script>
export default {
    name: 'SubtitleComponent',

    props: {
        id: {
            type: String,
            default: () => `subtitle-${Math.ceil(Math.random() * 10000)}`,
        },

        label: {
            type: String,
            default: '',
        },
    },
};
</script>

<style>
.subtitle-text {
    padding: 3px;
    text-align: left;
    font-size: 15px;
    color: var(--primary-light-smoke);
}
</style>
